export const styles = () => ({
  container: {
    marginBottom: 32,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '18px',
    color: 'rgba(53, 64, 82, 0.7)',
    textAlign: 'center',
    letterSpacing: '-0.01em',

    '& p': {
      // color: "inherit",
      // margin: 0
    },
  },
})
